import React from "react";

export const RegisterationForm = () => {
  return <div>RegisterationForm</div>;
};
